export default __webpack_public_path__ + "static/media/searchResult.539a2d82.svg";